import { Component, OnInit } from '@angular/core';
import { BaseIcon } from '../base-icon';

@Component({
	selector: 'app-icon-check',
	templateUrl: './icon-check.component.html',
	styleUrls: ['./icon-check.component.scss'],
})
export class IconCheckComponent extends BaseIcon implements OnInit {
	constructor() {
		super();
	}

	ngOnInit() {}
}
